import { map } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Area } from '@ridango/core';
import { NgRedux } from '@angular-redux/store';
import { AreasState } from './store/areas.store';
import { AreasActions } from './actions/areas.actions';

@Injectable({
    providedIn: 'root'
})
export class AreasService {
    constructor(
        @Inject('ENV') private env: any,
        private http: HttpClient,
        private ngRedux: NgRedux<AreasState>,
        private actions: AreasActions
    ) {}

    fetchAllAreas(channel = this.env.CHANNEL): Observable<Area[]> {
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/areas/channel/${channel}`;
        return this.http.get(url).pipe(
            map((a: Area[]) => {
                return a;
            })
        );
    }

    setAllAreas(areas: Area[]) {
        this.ngRedux.dispatch(this.actions.setAllAreas(areas));
    }
    setSelectedArea(area: Area) {
        this.ngRedux.dispatch(this.actions.setSelectedArea(area));
    }
}
